import { useSyncExternalStore } from "react";
import { LEDGER_COOKIE, type PiLedger } from "@hisense/shared";

/**
 * Sổ PI đang xem (Red PI, Roary 04/11/2026, mục 9): "PI thường" hay "Red PI", cho tài khoản có ô Xem Red PI.
 *
 * Gửi bằng cookie `hb_ledger` (không phải header như công tắc công ty) để cả ảnh `<img>`, tệp tải về, bản in mở tab mới cũng mang
 * theo — máy chủ lọc qua `documentVisibility`. Cookie không phải quyền: máy chủ bỏ qua nó nếu người này không có ô Xem Red PI.
 * Nhớ trong TAB (sessionStorage), không qua lần mở trình duyệt sau: mở lại là về sổ thường, không ai lỡ ở sổ Red mà không biết.
 */
let userKey: string | null = null;
let ledger: PiLedger = "normal";
const listeners = new Set<() => void>();
const storageKey = (id: string) => `hisense.ledger.${id}`;

function writeCookie(next: PiLedger) {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = next === "red"
    ? `${LEDGER_COOKIE}=red; Path=/api; SameSite=Strict${secure}`
    : `${LEDGER_COOKIE}=; Path=/api; Max-Age=0; SameSite=Strict${secure}`;
}

function emit() {
  for (const l of listeners) l();
}

/** Gọi khi biết người dùng. `canSee` = có ô Xem Red PI; không có thì luôn sổ thường và xoá cookie. */
export function bindLedgerUser(userId: string | null, canSee: boolean) {
  const nextKey = userId && canSee ? userId : null;
  let next: PiLedger = "normal";
  if (nextKey) {
    try {
      next = window.sessionStorage.getItem(storageKey(nextKey)) === "red" ? "red" : "normal";
    } catch {
      next = "normal";
    }
  }
  writeCookie(next);
  if (nextKey === userKey && next === ledger) return;
  userKey = nextKey;
  ledger = next;
  emit();
}

export function setLedger(next: PiLedger) {
  if (!userKey) return;
  ledger = next;
  try {
    if (next === "red") window.sessionStorage.setItem(storageKey(userKey), "red");
    else window.sessionStorage.removeItem(storageKey(userKey));
  } catch {
    /* chặn bộ nhớ — vẫn đổi trong phiên này */
  }
  writeCookie(next);
  emit();
}

export const getLedger = () => ledger;

export function useLedger(): PiLedger {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => ledger,
    () => "normal",
  );
}
